import React, {
  useRef,
  Fragment,
  useContext,
  useEffect,
  memo,
  useCallback,
} from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

import Logo from "./Logo";
import ProLogsUserMenu from "./ProLogsUserMenu";
// import LanguageSelector from "./LanguageSelector";
import DarkModeSwitch from "./DarkModeSwitch";
import { Divider, useMediaQuery } from "@material-ui/core";
import "./AppBar.css";
import { isEmpty } from "lodash";
import { Void } from "../common/data-grid-fields/Void";
import { StaticAppBar } from "./StaticAppBar";
import { LayoutContext, setAppBarHeightChanged } from "./LayoutContext";
import { useActionPermissions } from "../../common/auth/useActionPermissions";
import { AppBarFiltersContainerContext } from "../common/app-bar-filters/AppBarFiltersContainerContext";

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  spacer: {
    flex: 1,
  },
});

const hiddenButonStyle = `header > div.MuiToolbar-root > button:first-child {
  visibility: hidden;
}

header > div.MuiToolbar-root > button:last-child {
  display: none;
}`;

const CustomAppBar = (props: any) => {
  const classes = useStyles();
  const { setContainer } = useContext(AppBarFiltersContainerContext);
  const permissions = useActionPermissions();
  const hideMenuButton = !permissions || isEmpty(permissions);
  const UserMenu = hideMenuButton ? <Void /> : <ProLogsUserMenu />;
  const layoutContext = useContext(LayoutContext);
  const appBarRef = useRef<HTMLElement>(null);
  const isXSmall = useMediaQuery("(min-width:1080px)");
  const showUserOptions = useMediaQuery("(min-width:992px)");
  const containerCallback = useCallback(
    (ref) => {
      if (setContainer && ref) {
        setContainer(ref);
      }
    },
    [setContainer]
  );

  useEffect(() => {
    const handleResize = () => {
      if (!appBarRef.current) {
        return;
      }

      if (!layoutContext?.dispatch) {
        return;
      }

      if (layoutContext.appBarHeight === appBarRef.current.clientHeight) {
        return;
      }

      layoutContext.dispatch(
        setAppBarHeightChanged(appBarRef.current.clientHeight)
      );
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (!appBarRef.current) {
      return;
    }

    if (!layoutContext?.dispatch) {
      return;
    }

    if (layoutContext.appBarHeight === appBarRef.current.clientHeight) {
      return;
    }

    layoutContext.dispatch(
      setAppBarHeightChanged(appBarRef.current.clientHeight)
    );
  });

  return (
    <Fragment>
      {hideMenuButton && <style>{hiddenButonStyle}</style>}
      <StaticAppBar
        {...props}
        position="fixed"
        className="prologs-appbar"
        elevation={5}
        userMenu={UserMenu}
        ref={appBarRef}>
        <Logo />
        {!isXSmall && <div style={{ flex: 1 }}></div>}
        {isXSmall && (
          <>
            <Divider orientation="vertical" variant="middle" flexItem />

            <Typography
              variant="h6"
              color="inherit"
              className={classes.title + " react-admin-title-desktop"}
              id="react-admin-title"
            />
          </>
        )}

        {showUserOptions && (
          <div
            className="appbar-filters-container-desktop"
            id="appbar-filters-container"
            ref={containerCallback}></div>
        )}
        <Divider orientation="vertical" variant="middle" flexItem />
        <DarkModeSwitch />
        {/*<LanguageSelector />*/}
      </StaticAppBar>
    </Fragment>
  );
};

export default memo(CustomAppBar);
